export const glAppInterface = {
  101: 'Inwards Policy - Premium',
  102: 'Inwards Policy - Discount',
  103: 'Inwards Policy - Premium GST',
  104: 'Inwards Policy - Commission 1',
  105: 'Inwards Policy - Commission 1 GST',
  106: 'Inwards Policy - Policy Stamp',
  107: 'Inwards Policy - Policy Fee',
  108: 'Inwards Policy - Policy Tax',
  109: 'Inwards Policy - Risk Stamp',
  110: 'Inwards Policy - Risk Fee',
  111: 'Inwards Policy - Risk Tax',
  112: 'Inwards Policy - Business Tax',
  113: 'Inwards Policy - Business Tax Payable',
  114: 'Inwards Policy - Business Stamp',
  115: 'Inwards Policy - Business Stamp Payable',
  191: 'Inwards Policy - Coinsurance Service Fee',
  192: 'Inwards Policy - Coinsurance Service Fee GST',
  201: 'Inwards Policy - Tabarru 1',
  202: 'Inwards Policy - Tabarru 2',
  301: 'Inwards Policy - Commission 2',
  302: 'Inwards Policy - Commission 2 GST',
  401: 'Inwards Policy - Commission 3',
  402: 'Inwards Policy - Commission 3 GST',
  501: 'Outwards Facultative Reinsurance - Premium',
  502: 'Outwards Facultative Reinsurance - Commission 1 & 2',
  504: 'Outwards Facultative Reinsurance - Cession Stamp',
  505: 'Outwards Facultative Reinsurance - Levy',
  506: 'Outwards Facultative Reinsurance - Premium GST',
  507: 'Outwards Facultative Reinsurance - Commission GST',
  601: 'Outwards Coinsurance - Premium',
  602: 'Outwards Coinsurance - Commission 1 & 2',
  604: 'Outwards Coinsurance - Cession Stamp',
  605: 'Outwards Coinsurance - Levy',
  606: 'Outwards Coinsurance - Premium GST',
  607: 'Outwards Coinsurance - Commission GST',
  691: 'Outwards Coinsurance - Service Fee',
  692: 'Outwards Coinsurance - Service Fee GST',
  701: 'Outwards Treaty Reinsurance - Premium',
  702: 'Outwards Treaty Reinsurance - Commission 1 & 2',
  703: 'Outwards Treaty Reinsurance - Profit Commission',
  704: 'Outwards Treaty Reinsurance - Cession Stamp',
  705: 'Outwards Treaty Reinsurance - Levy',
  706: 'Outwards Treaty Reinsurance - Premium GST',
  707: 'Outwards Treaty Reinsurance - Commission GST',
  1001: 'Inwards Claims Payment',
  1002: 'Inwards Claims Payment - Input GST',
  1003: 'Inwards Claims Payment - Output GST',
  1004: 'Inwards Claims Payment - Deemed Input GST',
  1501: 'Outwards Claims Facultative Reinsurance Recovery',
  1601: 'Outwards Claims Coinsurance Recovery',
  1701: 'Outwards Claims Treaty Recovery',
  2000: 'UPR',
  2001: 'UPR - Gross - Premium',
  2002: 'UPR - Gross - Commission',
  2011: 'UPR - Facultative Reinsurance - Premium',
  2012: 'UPR - Facultative Reinsurance - Commission',
  2021: 'UPR - Treaty Reinsurance - Premium',
  2022: 'UPR - Treaty Reinsurance - Commission',
  2031: 'UPR - Statutory - Premium',
  2032: 'UPR - Statutory - Commission',
  2100: 'UPR Control',
  2101: 'UPR Control - Gross - Premium',
  2102: 'UPR Control - Gross - Commission',
  2111: 'UPR Control - Facultative Reinsurance - Premium',
  2112: 'UPR Control - Facultative Reinsurance - Commission',
  2121: 'UPR Control - Treaty Reinsurance - Premium',
  2122: 'UPR Control - Treaty Reinsurance - Commission',
  2131: 'UPR Control - Statutory - Premium',
  2132: 'UPR Control - Statutory - Commission',
  3000: 'Unreleased UPR',
  3100: 'Unreleased UPR Control',
  4000: 'Claims Reserve',
  4100: 'Claims Reserve Control',
  4200: 'Claims Reserve - Facultative Reinsurance',
  4300: 'Claims Reserve Control - Facultative Reinsurance',
  4400: 'Claims Reserve - Treaty Reinsurance',
  4500: 'Claims Reserve Control - Treaty Reinsurance',
  4600: 'Claims Reserve - Statutory ',
  4700: 'Claims Reserve Control - Statutory',
  5001: 'Debtors Control',
  5002: 'Difference in Exchange - Provision',
  5003: 'Difference in Exchange - Realised',
  5004: 'Write off Small Balance',
  5101: 'Bank Account',
  5102: 'Bank Charge',
  6001: 'Debtors Entry - Income/Expense/Asset/Liability',
  6002: 'Debtors Entry - Input GST',
  6003: 'Debtors Entry - Output GST',
  7001: 'Outwards Treaty Accounting Premium',
  7002: 'Outwards Treaty Accounting Commission',
  7003: 'Outwards Treaty Accounting Overriding Commission',
  7004: 'Outwards Treaty Accounting Profit Commission',
  7011: 'Outwards Treaty Accounting Premium Reserve Release',
  7012: 'Outwards Treaty Accounting Interest',
  7013: 'Outwards Treaty Accounting Tax',
  7021: 'Outwards Treaty Accounting Claims Payment',
  7022: 'Outwards Treaty Accounting Claims Reserve',
  7023: 'Outwards Treaty Accounting Claims Cash Call',
  8180: 'GL Adjustment',
  9000: 'Inwards Treaty Reinsurance',
  9100: 'Inwards Treaty Retrocession',
  9200: 'Outwards Treaty Reinsurance',
  9201: 'Outwards Treaty Reinsurance - Premium',
  9202: 'Outwards Treaty Reinsurance - Premium Reserve',
  9203: 'Outwards Treaty Reinsurance - Commission',
  9204: 'Outwards Treaty Reinsurance - Profit Commission',
  9205: 'Outwards Treaty Reinsurance - Claims',
  9206: 'Outwards Treaty Reinsurance - Claims Reserve',
  9207: 'Outwards Treaty Reinsurance - Claims Cash Call',
  9208: 'Outwards Treaty Reinsurance - Tax',
  9209: 'Outwards Treaty Reinsurance - Interest',
  9210: 'Outwards Treaty Reinsurance - Administrative Charge',
  9211: 'Outwards Treaty Reinsurance - Other'
}

// AR: Added OS-445
export const mapGLAC = {
  0: '0 - Not Applicable',
  1: '1 - Policy Type',
  2: '2 - Policy Type Analysis Code',
  3: '3 - Business Class',
  4: '4 - Business Class Analysis',
  5: '5 - Branch',
  6: '6 - Department',
  7: '7 - Country',
  8: '8 - Country Analysis Code',
  9: '9 - Agent Country',
  10: '10 - Agent Country Analysis Code',
  11: '11 - Cedant Country',
  12: '12 - Cedant Country Analysis Code',
  13: '13 - Reinsurer Country',
  14: '14 - Reinsurer Country Analysis Code',
  15: '15 - Agent',
  16: '16 - Agent Analysis Code 1 or 2',
  17: '17 - Agent Analysis Code 1 or 2',
  18: '18 - Policy Statistics',
  19: '19 - Risk Statistics',
  20: '20 - Claim Statistics',
  21: '21 - Debtors Module',
  22: '22 - Business Class Group',
  23: '23 - Branch Analysis Code',
  24: '24 - Reserve Category',
  25: '25 - Account Type',
  26: '26 - Custom Business Source',
  27: '27 - Cover Type',
  28: '28 - Billing Account',
  29: '29 - Account Payment or Receipts'
}

export const acctType = {
  I: 'Income',
  E: 'Expense',
  A: 'Assets',
  L: 'Liability'
}

export const postType = {
  P: 'Posting',
  S: 'Summary'
}
